import React from 'react';

const Multiline = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M15.859 4.06668C16.3745 4.26494 16.6316 4.84353 16.4333 5.359L11.4333 18.359C11.2351 18.8745 10.6565 19.1316 10.141 18.9334C9.62555 18.7351 9.3684 18.1565 9.56665 17.641L14.5667 4.64105C14.7649 4.12557 15.3435 3.86842 15.859 4.06668Z" />
    <path d="M8.70711 7.79292C9.09763 8.18344 9.09763 8.81661 8.70711 9.20713L6.41421 11.5L8.70711 13.7929C9.09763 14.1834 9.09763 14.8166 8.70711 15.2071C8.31658 15.5977 7.68342 15.5977 7.29289 15.2071L4.29289 12.2071C4.10536 12.0196 4 11.7652 4 11.5C4 11.2348 4.10536 10.9805 4.29289 10.7929L7.29289 7.79292C7.68342 7.40239 8.31658 7.40239 8.70711 7.79292Z" />
    <path d="M17.2929 7.79292C17.6834 7.40239 18.3166 7.40239 18.7071 7.79292L21.7071 10.7929C21.8946 10.9805 22 11.2348 22 11.5C22 11.7652 21.8946 12.0196 21.7071 12.2071L18.7071 15.2071C18.3166 15.5977 17.6834 15.5977 17.2929 15.2071C16.9024 14.8166 16.9024 14.1834 17.2929 13.7929L19.5858 11.5L17.2929 9.20713C16.9024 8.81661 16.9024 8.18344 17.2929 7.79292Z" />
    <path d="M21 5C21 4.44772 21.4477 4 22 4H25C26.6569 4 28 5.34315 28 7V25C28 26.6569 26.6569 28 25 28H7C5.34314 28 4 26.6569 4 25V20C4 19.4477 4.44772 19 5 19C5.55228 19 6 19.4477 6 20V26H26V6H22C21.4477 6 21 5.55228 21 5Z" />
  </svg>
);

export default Multiline;
